import checkURL from '@/helpers/checkURL'
import { PlatformOrigin } from '@/types/platform'
import { ELinkRel, EProtocol, ETarget } from '../containers/LinkForm/types'
import { AVAILABLE_PROTOCOLS, AVAILABLE_RELS } from '../config'
import { getAutoRel } from './getAutoRel'

export const applyAutoLinkAttributes = ({
  html,
  platformOrigin,
}: {
  html: string
  platformOrigin?: PlatformOrigin
}) => {
  if (!/<a\s/i.test(html)) {
    return html
  }

  const fragment = CKEDITOR.htmlParser.fragment.fromHtml(html)

  let hasChanges = false

  fragment.forEach((node) => {
    const element = node as CKEDITOR.htmlParser.element

    if (element.name !== 'a') {
      return
    }

    const { href } = element.attributes

    if (!checkURL(href)) {
      return
    }

    const url = new URL(href)

    if (!AVAILABLE_PROTOCOLS.includes(url.protocol as EProtocol)) {
      return
    }

    const { target } = element.attributes
    const hasValidRel = AVAILABLE_RELS.includes(
      element.attributes.rel as ELinkRel
    )

    if (!hasValidRel) {
      const rel = element.attributes.rel ?? null
      const autoRel = getAutoRel(href)

      if (autoRel) {
        element.attributes.rel = autoRel
      } else {
        delete element.attributes.rel
      }

      if (autoRel !== rel) {
        hasChanges = true
      }
    }

    if (!target && url.origin !== platformOrigin) {
      element.attributes.target = ETarget.BLANK

      hasChanges = true
    }
  }, CKEDITOR.NODE_ELEMENT)

  if (!hasChanges) {
    return html
  }

  const writer = new CKEDITOR.htmlParser.basicWriter()

  fragment.writeHtml(writer)

  return writer.getHtml(true)
}
